<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.go(-1)"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-text-field
              v-model="titulo"
              label="Describa en pocas palabras su consulta"
              required
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-textarea
            name="input-7-1"
            v-model="descripcion"
            label="Describa en detalle la consulta"
            >
            </v-textarea>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-file-input
              show-size
              v-model="files"
              :items="files"
              multiple
              counter
              accept="image/*"
              label="Adjuntar archivos"
            >
              <template v-slot:selection="{ text }">
                <v-chip
                  small
                  label
                  close
                  @click:close="remove(index)"
                  color="primary"
                >
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="addConsulta()"
            >
              Crear consulta
            </v-btn>
          </v-col>
        </v-row>
        <div>
          <br/>
          <h2>
            Mis consultas generales
          </h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    Título
                  </th>
                  <th class="text-center hideMobile">
                    Tiempo
                  </th>
                  <th class="text-center">
                    Descripción
                  </th>
                  <th class="text-center">
                    Respuesta
                  </th>
                  <th class="text-center">
                    Respondido por:
                  </th>
                  <th class="text-center">
                    Calificar
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(consultaData,
                  consultaKey) in consultas"
                  :key="consultaKey"
                >
                  <td :title="consultaData.titulo" style="max-width: 100px; overflow:hidden; text-overflow: ellipsis; white-space: nowrap;">{{ consultaData.titulo }}</td>
                  <td class="hideMobile" style="max-width: 50px; text-align:center;">{{ consultaData.tiempo }}</td>
                  <td class="alignMobile" style="max-width: 100px;">
                    <div class="text-center">
                      <v-dialog
                        v-model="dialog_desc[consultaKey]"
                        @input="dialog_desc[consultaKey] = $event"
                        width="500"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            class="hideMobile"
                            color="blue lighten-2"
                            dark
                            x-small
                            v-bind="attrs"
                            v-on="on"
                          >
                            Ver descripción
                          </v-btn>
                          <v-btn
                            class="hideDesktop"
                            color="blue lighten-2"
                            fab
                            x-small
                            dark
                            elevation="7"
                            v-bind="attrs"
                            v-on="on"
                            title="Ver descripción"
                          >
                            <v-icon color="white">mdi-eye</v-icon>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            Consulta
                          </v-card-title>
                          <v-card-text style="margin-top:10px">
                            {{ consultaData.descripcion }}
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </div>
                  </td>

                  <td class="alignMobileText" v-if="consultaData.ConsultaGeneralesRespuesta">
                    <div class="text-center alignMobile">
                      <v-dialog
                        v-model="dialog[consultaKey]"
                        @input="dialog[consultaKey] = $event"
                        width="500"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="green lighten-2"
                            dark
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            class="hideMobile"
                          >
                            Ver respuesta
                          </v-btn>

                          <v-btn
                            class="hideDesktop"
                            color="green lighten-2"
                            fab
                            x-small
                            dark
                            elevation="7"
                            v-bind="attrs"
                            v-on="on"
                            title="Ver respuesta">
                            <v-icon color="white">mdi-eye</v-icon>
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            Respuesta
                          </v-card-title>
                          <v-card-text style="margin-top:10px">
                            {{ consultaData.ConsultaGeneralesRespuesta.respuesta }}
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </div>
                  </td>
                  <td v-else class="alignMobileText">Aún no respondido...</td>
                  
                  <td class="alignMobileText">
                    <div class="text-center alignMobile">
                      {{ consultaData.usu_nombre || '' }}
                    </div>
                  </td>
                  <td >
                    <star-rating v-if="consultaData.ConsultaGeneralesRespuesta" v-model="consultaData.puntaje" @rating-selected="calificar($event,consultaData.id,'G')" v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#f1f1f1"
                        active-color="#FFD700" v-bind:star-size="20" v-bind:read-only="(consultaData.tiene_puntuacion=='S'?true:false)" v-bind:show-rating="false">

                      </star-rating>
                  </td>
                  
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <br/>
          <h2>
            Mis Informes de Pagos
          </h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">
                    Título
                  </th>
                  <th class="text-center hideMobile">
                    Tiempo
                  </th>
                  <th class="text-center">
                    Respuesta
                  </th>
                  <th class="text-center">
                    Respondido por:
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(consultaDat,
                  consultaKey) in consultasAcreditacion"
                  :key="consultaKey"
                >
                  <td :title="consultaDat.titulo" style="max-width: 100px; overflow:hidden; text-overflow: ellipsis; white-space: nowrap;">{{ consultaDat.titulo }}</td>
                  <td class="hideMobile" style="max-width: 50px; text-align:center;">{{ consultaDat.tiempo }}</td>
                  

                  <td class="alignMobileText" v-if="consultaDat.ConsultaAcreditacionRespuesta">
                    <div class="text-center alignMobile">
                      <v-dialog
                        v-model="dialog_acred[consultaKey]"
                        @input="dialog_acred[consultaKey] = $event"
                        transition="dialog-bottom-transition"
                        width="500"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="green lighten-2"
                            dark
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            class="hideMobile"
                            @click="printConsole(consultaDat)"
                          >
                            Ver respuesta
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            Respuesta
                          </v-card-title>
                          <v-card-text id="acredRespuesta" style="margin-top: 10px;">
                            {{ respuestaAcreditacion }}
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </div>
                  </td>
                  <td v-else class="alignMobileText">Aún no respondido...</td>

                  <td class="alignMobileText">
                    <div class="text-center alignMobile">
                      {{ consultaDat.usu_nombre || '' }}
                    </div>
                  </td>
                  <td>
                    <star-rating v-if="consultaDat.ConsultaAcreditacionRespuesta" v-model="consultaDat.puntaje" @rating-selected="calificar($event,consultaDat.id,'A')" v-bind:increment="0.5" v-bind:max-rating="5" inactive-color="#f1f1f1"
                        active-color="#FFD700" v-bind:star-size="20" v-bind:read-only="(consultaDat.tiene_puntuacion=='S'?true:false)" v-bind:show-rating="false">

                      </star-rating>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

        </div>
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Consulta",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
    StarRating
  },

  data: () => ({
    title:"Nueva consulta",
    dialog_desc: [],
    dialog: [],
    dialog_acred: [],
    titulo: '',
    descripcion: '',
    consultas:[],
    consultasAcreditacion:[],
    files:[],
    respuestaAcreditacion : '',
    rating:3
  }),

  methods: {

    async calificar(puntaje,idConsulta,tipo){
      let url = "consultas-generales/calificar";
      let params = new FormData();
      params.append('id_consulta',idConsulta);
      params.append('puntaje',puntaje);
      params.append('tipo',tipo);

      await this.$API
        .post({
          url: url,
          data: params
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
        });  
    },
    remove (index) {
      this.files.splice(index, 1)
    },

    printConsole(data){
      // alert(JSON.stringify())
      // debugger;
      // console.log(data);
      this.respuestaAcreditacion = data.ConsultaAcreditacionRespuesta.respuesta
    },
    
    async addConsulta() {
      if(this.titulo.trim() == "" || this.descripcion.trim() == ""){
        alert('Escribe el titulo y descripción de tu consulta')
        return;
      }
      var formData = new FormData();
      formData.append('titulo',this.titulo);
      formData.append('descripcion',this.descripcion);
      formData.append('cantidadImagen',this.files.length);

      console.log(this.$refs)
      let i = 0;
      for (let file of this.files) {
          formData.append(`imagen_${i}`, file, file.name);
          i++;
      }
      console.log(formData);
      
      let url = "consultas-generales/store";
      await this.$API
        .post({
          url: url,
          data: formData
        }).then(() => {
          this.loadConsultas();
          this.titulo = "";
          this.descripcion = "";
          this.files = [];
        });  
    },
    async loadConsultas() {
      let url = "consultas-generales";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultas = res;
          for (let index = 0; index < this.consultas.length; index++) {
            this.dialog = [];
            this.dialog[index] = false;
            this.dialog_desc = [];
            this.dialog_desc[index] = false;
          }
        });
    }
  },
  async loadConsultasAcreditacion() {
      let url = "consultas-acreditacion";
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.consultasAcreditacion = res;
          for (let index = 0; index < this.consultasAcreditacion.length; index++) {
            this.dialog_acred = [];
            this.dialog_acred[index] = false;
          }
        });
  },

  mounted() {
    this.$API
      .get({
        url: "consultas-generales"
      }).then((res) => {
        this.consultas = res;
      });

    this.$API
      .get({
        url: "consultas-acreditacion"
      }).then((res) => {
        this.consultasAcreditacion = res;
      });
  },
};
</script>
